import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleContainerDirective } from 'src/app/modules/directives/module-container.directive';
import { map } from 'rxjs';
import { ReadyForContactFormComponent } from '../../components/ready-for-contact-form/ready-for-contact-form.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-legal-notice-page',
  standalone: true,
  imports: [
    CommonModule,
    ModuleContainerDirective,
    ReadyForContactFormComponent,
  ],
  templateUrl: './legal-notice-page.component.html',
  styleUrl: './legal-notice-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalNoticePageComponent {
  private readonly route = inject(ActivatedRoute);
  public readonly data$ = this.route.data.pipe(map(d => d['data']));
}
